import React from 'react';
import { useModal } from 'hooks/useModal';
import { formatDate } from 'utils/formatter';
import { DividendHeader, FooterText } from 'pages/DividendPrediction';
import Loading from 'components/commons/loading/Loading';
import { DividendDepositModal } from './DividendTransition';
import { AboutDepositDataModal } from '../modal/AboutDepositDataModal';

export const DividendError = ({ type }: { type: 'broker' | 'deposit' }) => {
  const [isShowModal, { hideModal, showModal }] = useModal();
  const date = formatDate(new Date(), 'yyyy年 M月');

  return (
    <>
      <DividendHeader {...{ type: 'deposit' }} />
      <div className="bg-white text-bluegray-700 pb-6">
        <div className="pt-6 text-center font-bold">{date}</div>
        <div className="px-4 mt-2 text-center text-xs">
          <span className="mr-1 text-2xl font-bold">---</span>円
        </div>
        {type === 'broker' ? (
          <div className="relative my-2">
            <img
              src="/static/images/dividend/var_chart.png"
              alt="バーチャート"
              className="mx-auto"
              height="188"
              width="343"
            />
            <div
              className="absolute w-56 flex flex-col items-center py-3 mx-auto bg-bluegray-50 border border-bluegray-300 rounded-lg"
              style={{ top: '34%', right: 0, left: 0 }}>
              <div className="text-sm text-bluegray-500 font-bold">
                入金情報がありません
              </div>
              <div
                className="flex flex-row items-center mt-1 text-blue-700 cursor-pointer"
                onClick={showModal}>
                <div className="text-xs">表示されない理由について</div>
                <div className="icon-info ml-1" />
              </div>
            </div>
          </div>
        ) : (
          <div className="relative my-2">
            <img
              src="/static/images/dividend/no_deposit_data.svg"
              alt="入金情報がありません"
              className="mx-auto"
              height="188"
              width="343"
            />
          </div>
        )}
        <DividendDepositModal />
        <div
          className="grid mt-4 px-4 py-1 text-sm text-bluegray-550 font-bold bg-gray-300"
          style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="ml-2">日付</div>
          <div>入金額</div>
        </div>
        <div
          className="grid items-center px-4 py-3 border-b border-gray-300"
          style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="ml-2">----/--</div>
          <div className="flex flex-row items-center ml-auto">
            ---
            <div className="w-10" />
          </div>
        </div>
      </div>
      <AboutDepositDataModal {...{ hide: hideModal, isShow: isShowModal }} />
    </>
  );
};

export const DividendDepositLoading = ({ str }: { str: string }) => {
  return (
    <>
      <DividendHeader {...{ type: 'deposit' }} />
      <div className="bg-white text-bluegray-700">
        <div className="pt-6 text-center text-base font-bold">----年 --月</div>
        <div className="px-4 mt-2 text-center text-xs">
          <span className="mr-1 text-2xl font-bold">---</span>円
        </div>
        <Loading
          loading={true}
          circularLoading={true}
          style={{
            paddingTop: '90px',
            paddingBottom: '90px',
          }}
        />
        <div
          className="grid px-4 py-1 text-sm text-bluegray-550 font-bold bg-gray-300"
          style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="ml-2">{str}</div>
          <div>入金額</div>
        </div>
        <div className="pb-6">
          <Loading
            loading={true}
            circularLoading={true}
            style={{
              paddingTop: '170px',
              paddingBottom: '170px',
            }}
          />
        </div>
      </div>
      <FooterText />
    </>
  );
};
